import {
    CREATEPATHOLOGYCATEGORY,
    GETPATHOLOGYCATEGORY,
    UPDATEPATHOLOGYCATEGORY,
    DELETEPATHOLOGYCATEGORY,
    CREATEPATHOLOGYUNIT,
    GETPATHOLOGYUNIT,
    UPDATEPATHOLOGYUNIT,
    DELETEPATHOLOGYUNIT,
    CREATEPATHOLOGYPARAMETER,
    GETPATHOLOGYPARAMETER,
    UPDATEPATHOLOGYPARAMETER,
    DELETEPATHOLOGYPARAMETER,
    CREATEPATHOLOGIST,
    GETPATHOLOGIST,
    UPDATEPATHOLOGIST,
    DELETEPATHOLOGIST,
    CREATEPATHOLOGYCENTER,
    GETRADIOLOGYCENTER,
    GETPATHOLOGYCENTER,
    UPDATEPATHOLOGYCENTER,
    DELETEPATHOLOGYCENTER,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEPATHOLOGYCATEGORY:
            return {
                ...state,
                pathologycatrgorySaveStatus: action.payload.success,
            }
        case GETPATHOLOGYCATEGORY:
                return {
                        ...state,
                        pathologycategoryList: action.payload.data,
                        }
        case UPDATEPATHOLOGYCATEGORY:
                return {
                        ...state,
                        pathologycategoryUpdateStatus: action.payload.success,
                        }   

        case DELETEPATHOLOGYCATEGORY:
                 return {
                     ...state,
                     pathologycategoryDeleteStatus: action.payload.success,
                        } 
        case CREATEPATHOLOGYUNIT:
                return {
                        ...state,
                        pathologyunitSaveStatus: action.payload.success,
                        }
        case GETPATHOLOGYUNIT:
                return {
                        ...state,
                        pathologyunitList: action.payload.data,
                       }
        case UPDATEPATHOLOGYUNIT:
                return {
                        ...state,
                        pathologyunitUpdateStatus: action.payload.success,
                       }   
                
        case DELETEPATHOLOGYUNIT:
                 return {
                        ...state,
                        pathologyunitDeleteStatus: action.payload.success,
                        } 
        case CREATEPATHOLOGYPARAMETER:
                return {
                        ...state,
                        pathologyparameterSaveStatus: action.payload.success,
                        }
        case GETPATHOLOGYPARAMETER:
                return {
                        ...state,
                        pathologyparameterList: action.payload.data,
                        }
        case UPDATEPATHOLOGYPARAMETER:
                return {
                        ...state,
                        pathologyparameterUpdateStatus: action.payload.success,
                        }   
                            
        case DELETEPATHOLOGYPARAMETER:
                return {
                        ...state,
                        pathologyparameterDeleteStatus: action.payload.success,
                        } 
        case CREATEPATHOLOGIST:
                return {
                        ...state,
                        pathologistSaveStatus: action.payload.success,
                        }
        case GETPATHOLOGIST:
                return {
                        ...state,
                        pathologistList: action.payload.data,
                       }
        case UPDATEPATHOLOGIST:
                return {
                        ...state,
                        pathologistUpdateStatus: action.payload.success,
                       }   
                
        case DELETEPATHOLOGIST:
                 return {
                        ...state,
                        pathologistDeleteStatus: action.payload.success,
                        } 
        case CREATEPATHOLOGYCENTER:
                return {
                        ...state,
                        pathologycenterSaveStatus: action.payload.success,
                        }
        case GETPATHOLOGYCENTER:
                return {
                        ...state,
                        pathologycenterList: action.payload.data,
                       }
        case UPDATEPATHOLOGYCENTER:
                return {
                        ...state,
                        pathologycenterUpdateStatus: action.payload.success,
                       }   
                
        case DELETEPATHOLOGYCENTER:
                 return {
                        ...state,
                        pathologycenterDeleteStatus: action.payload.success,
                        } 
                        default:
                            return state
                                  }
                             }